"use strict";

var _regeneratorRuntime = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _asyncToGenerator = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _classCallCheck = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/createClass.js");

var _excluded = ["transformers", "fieldMappings"],
    _excluded2 = ["transformers", "fieldMappings"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchActions = exports.leadIdActions = exports.baseActions = void 0;

var camelCase_1 = __importDefault(require("lodash/camelCase"));

var utils_1 = require("../common/utils");

var fetch_client_1 = require("../common/fetch-client");

exports.baseActions = ["post"];
exports.leadIdActions = ["review", "update"];
var EXTRA_PAYLOAD_MAPPINGS = {
  email: ["emailAddress"],
  phoneNumber: ["phoneHome", "phoneCustom"],
  provinceCode: ["province"],
  postalCode: ["zipCode", "postalCode"],
  position: ["jobTitle"]
};

var FetchActions = /*#__PURE__*/function () {
  function FetchActions(baseUrl, leadType) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$transformers = _ref.transformers,
        transformers = _ref$transformers === void 0 ? {} : _ref$transformers,
        _ref$fieldMappings = _ref.fieldMappings,
        fieldMappings = _ref$fieldMappings === void 0 ? {} : _ref$fieldMappings,
        options = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, FetchActions);

    this.transformers = transformers;
    this.fieldMappings = fieldMappings;
    this.client = (0, fetch_client_1.fetchClientFactory)(baseUrl, _objectSpread({
      mode: "cors"
    }, options));
    this.leadType = leadType;
  }

  _createClass(FetchActions, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathName, body) {
        var _ref2,
            _ref2$transformers,
            transformers,
            _ref2$fieldMappings,
            fieldMappings,
            options,
            useTransformers,
            useFieldMappings,
            payload,
            response,
            parsedResponse,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref2$transformers = _ref2.transformers, transformers = _ref2$transformers === void 0 ? {} : _ref2$transformers, _ref2$fieldMappings = _ref2.fieldMappings, fieldMappings = _ref2$fieldMappings === void 0 ? {} : _ref2$fieldMappings, options = _objectWithoutProperties(_ref2, _excluded2);

                /** Transformers to use on payload */
                useTransformers = _objectSpread(_objectSpread({}, this.transformers), transformers);
                /** Field mappings to use on payload */

                useFieldMappings = _objectSpread(_objectSpread({}, this.fieldMappings), fieldMappings);

                if (!(!Array.isArray(body) && typeof body !== "object")) {
                  _context.next = 5;
                  break;
                }

                throw new Error("Body must be an object!");

              case 5:
                /* payload transformations */
                payload = Object.entries(body).reduce(function (acc, _ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      key = _ref4[0],
                      val = _ref4[1];

                  /* payload value transformations */
                  var transformer = useTransformers.hasOwnProperty(key) && typeof useTransformers[key] === "function" ? useTransformers[key] : function () {
                    return val;
                  };
                  var newVal = transformer(val);
                  /* payload key mappings */

                  if (useFieldMappings.hasOwnProperty(key) && typeof useFieldMappings[key] === "string") {
                    key = useFieldMappings[key] || key;
                  }
                  /* camelCase → snakeCase transformations on payload keys */


                  acc[(0, utils_1.snakeCase)(key)] = newVal;

                  if (key in EXTRA_PAYLOAD_MAPPINGS) {
                    EXTRA_PAYLOAD_MAPPINGS[key].forEach(function (field) {
                      var mappedField = (0, utils_1.snakeCase)(field);

                      if (!(mappedField in acc)) {
                        acc[mappedField] = newVal;
                      }
                    });
                  }

                  return acc;
                }, {});
                _context.next = 8;
                return this.client(pathName, _objectSpread(_objectSpread({
                  method: "POST"
                }, options), {}, {
                  body: payload
                }));

              case 8:
                response = _context.sent;

                /* snakeCase → camelCase on returned values */
                parsedResponse = Object.entries(response).reduce(function (acc, _ref5) {
                  var _ref6 = _slicedToArray(_ref5, 2),
                      key = _ref6[0],
                      val = _ref6[1];

                  acc[(0, camelCase_1.default)(key)] = val;
                  return acc;
                }, {});
                return _context.abrupt("return", parsedResponse);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute(_x, _x2) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return FetchActions;
}();

exports.FetchActions = FetchActions;